export const Border = `border border-4 rounded-lg border-white`
